import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

export const feedbackApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    getFeedback: builder.query({
      query: () => {
        return {
          url: `feedback`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ["Static"],
    }),
  }),
});

export const { useGetFeedbackQuery } = feedbackApi;
